<script setup>
import AutocompleteFilter from '@/components/widgets/AutocompleteFilter.vue';
import { inject, ref, onMounted, watch } from 'vue';
import { useInfinite } from '@/composables/use-infinity';

const backendApi = inject('backendApi');
const selected = ref(null);

const props = defineProps({
    hideLabel: {
        type: Boolean,
        default: false
    },
    itemTitle: {
        default: 'name'
    },
    itemValue: {
        default: 'id'
    },
    args: {
        type: Object,
        default: () => ({})
    }
});

const fetchCities = ({ pattern, page, limit }) => {
    const countryId = props.args?.countryId?.id ?? props.args?.countryId;
    return backendApi().city().companySearch({
        pattern,
        country: countryId,
        page,
        limit
    });
};

const {
    items: cities,
    loading: isLoading,
    showRetryButton,
    hasMore,
    searchQuery,
    getItems,
    loadMore,
    reset
} = useInfinite(fetchCities);

const emit = defineEmits(['update']);

const handleSearch = () => {
    reset();
    getItems();
};

// Si cambia el país, resetea y busca de nuevo
watch(
    () => props.args?.countryId,
    () => {
        emit('update', null);
        handleSearch();
    },
    { immediate: true }
);

onMounted(() => {
    getItems();
});
</script>

<template>
    <AutocompleteFilter
        v-model="selected"
        v-model:search="searchQuery"
        :item-title="'name'"
        :item-value="'id'"
        :items="cities"
        :label="hideLabel ? '' : $t('City')"
        :loading="isLoading"
        :show-retry-button="showRetryButton"
        :infinite-scroll="hasMore"
        @infinite-scroll="loadMore"
        @update="emit('update', selected)"
        @preparing-search="handleSearch"
        @search="handleSearch"
        @retry="handleSearch"
    >
        <template v-slot:default="{ props, item }">
            <v-list-item
                v-bind="props"
                :title="item.raw.name"
                :subtitle="`${item.raw.state?.name ?? ''}${item.raw.state?.country?.name ? ', ' + item.raw.state.country.name : ''}`"
            />
        </template>
        <template v-if="$slots.prepend" v-slot:prepend>
            <slot name="prepend"></slot>
        </template>
    </AutocompleteFilter>
</template>
